import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';
import { DatabaseIndice } from '../alcance/interfaces/database';

@Injectable({providedIn: 'root'})
export class ListaReposicaoItemDBService extends DatabaseService {
    override classname = 'ListaReposicaoItemDBService';
    override table = 'lista_reposicao_item';
    override keyPath = 'uuid';
    override typeKey = 'TEXT';
    protected override useUuidKey = true;

    override indices: DatabaseIndice[] = [
        {name: 'by_id', field: 'id', unique: false, multiEntry: false},
        {name: 'by_edificacao', field: 'edificacao_id', unique: false, multiEntry: false},
        {name: 'by_estabelecimento', field: 'estabelecimento_id', unique: false, multiEntry: false},
        {name: 'by_descricao', field: 'descricao', unique: false, multiEntry: false},
        {name: 'by_ativo', field: 'ativo', unique: false, multiEntry: false},
        {name: 'by_sinc', field: 'sinc', unique: false, multiEntry: false},
    ];

    protected override filterSql(sql: string, params: any): string {
        const add = (clause: string) => sql += (sql.includes('WHERE') ? ' AND ' : ' WHERE ') + clause;
        if(params?.edificacao_id) add(`by_edificacao = '${params.edificacao_id}'`);
        if(params?.estabelecimento_id) add(`by_estabelecimento = '${params.estabelecimento_id}'`);
        if(params?.ativo !== undefined) add(`by_ativo = '${params.ativo ? 1 : 0}'`);
        if(params?.descricao){
            const termo = String(params.descricao).replace(/'/g, "''");
            add(`by_descricao LIKE '%${termo}%'`);
        }
        return sql;
    }
}
